"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ContentTypeSystemAttributes = /** @class */ (function () {
    function ContentTypeSystemAttributes(data) {
        Object.assign(this, data);
    }
    return ContentTypeSystemAttributes;
}());
exports.ContentTypeSystemAttributes = ContentTypeSystemAttributes;
//# sourceMappingURL=content-type-system-attributes.class.js.map